export default __webpack_public_path__ + "static/media/about-thumb.a2b41625.jpg";